import { createSlice } from "@reduxjs/toolkit";
import { historyApi } from "./history.api";
// Api response type
const initialState = {
    currentTier: null,
    history: [],
    dictionary: {},
    config: {}
};
export const historySlice = createSlice({
    name: "history",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(historyApi.endpoints.getHistory.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
//# sourceMappingURL=history.slice.js.map